import { render } from "./Project.vue?vue&type=template&id=b2082592&scoped=true"
import script from "../js/project.js?vue&type=script&lang=js"
export * from "../js/project.js?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=b2082592&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2082592"]])

export default __exports__